// extracted by mini-css-extract-plugin
export default {"backers":"Ij_6csFb11iLOSkn99lu","h2":"oTcoXkW4IFQ3xBoh_72I","backersBackers":"NOXcDEQCV9hhmhV4Y3gb"};